// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "v2.1.18-0-g3fa58012b",
    "hash": "g3fa58012b",
    "distance": 0,
    "tag": "v2.1.18",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v2.1.18",
        "major": 2,
        "minor": 1,
        "patch": 18,
        "prerelease": [],
        "build": [],
        "version": "2.1.18"
    },
    "suffix": "0-g3fa58012b",
    "semverString": "2.1.18",
    "version": "2.1.18",
    "versionDateTime": "2026-09-29T05:51:57.245Z"
};
